import useAdminAccess from "hooks/useAdminAccess";
import {
  httpDecideAddressVerification,
  httpFetchKycReviews,
  httpFetchVerificationEmails,
  httpGetKycReview,
  httpDecideIdentityVerification,
} from "api/admin/user";
import AddressVerificationReviews from "components/compliance/AddressVerificationReviews";
import AdminSidebar from "components/layout/AdminSidebar";

const AdminAddressVerificationReviews = () => {
  const { can } = useAdminAccess();
  return (
    <AddressVerificationReviews
      reviewerType="admin"
      canDecideAddress={can("compliance.addressReviews.approve")}
      canDecideIdentity={can("users.kyc.approve")}
      kycView
      Sidebar={AdminSidebar}
      fetchReviews={httpFetchKycReviews}
      fetchReview={httpGetKycReview}
      fetchEmails={httpFetchVerificationEmails}
      decideIdentity={httpDecideIdentityVerification}
      decideReview={httpDecideAddressVerification}
    />
  );
};

export default AdminAddressVerificationReviews;
